export const DOMAIN_NAME = "imbaweb.com"

export const FORM_MODE = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  READ_ONLY: 'READ_ONLY'
}

export const DATA_TYPE = {
  'STRING': 'STRING',
  'UUID': 'UUID',
  'TEXT': 'TEXT',
  'BOOLEAN': 'BOOLEAN',
  'INTEGER': 'INTEGER',
  'SEQUENCE': 'SEQUENCE',
  'DECIMAL': 'DECIMAL',
  'MONEY': 'MONEY',
  'DATETIME': 'DATETIME',
  'DATE': 'DATE',
  'LIST_GROUP': 'LIST_GROUP',
  'MODEL': 'MODEL',
  'JSON': 'JSON',
  'COMPOSITE': 'COMPOSITE'
}

export const DATA_TYPE_TO_GRAPHQL = {
  'STRING': 'String',
  'UUID': 'String',
  'TEXT': 'String',
  'BOOLEAN': 'Boolean',
  'INTEGER': 'Int',
  'SEQUENCE': 'Int',
  'DECIMAL': 'Float',
  'MONEY': 'Float',
  'DATETIME': 'DateTime',
  'DATE': 'Date',
  'LIST_GROUP': 'String',
  'MODEL': 'String',
  'JSON': 'String',
  'COMPOSITE': 'String'
}

export const TENANT_NAME = window.TENANT_NAME

// ---------- IMAGE BUCKET  ---------- 

export const GLOBAL_BUCKET = `https://storage.googleapis.com/images.imbaweb.com`

export const TENANT_BUCKET = `https://storage.googleapis.com/${TENANT_NAME}-images.imbaweb.com`

// ---------- DESIGNER MODE  ---------- 

export const DESIGNER_MODE = false

// ---------- LANGUAGE ---------- 

// export const LANGUAGE = {
//   en: { nativeName: 'English' },
//   bm: { nativeName: 'Malay' },
//   zh: { nativeName: '中文' }
// }

// ---------- PAGE ---------- 

export const PAGE_DATA = {

  "HOME": {
    name: "home",
    url: "/",
    value: 'MALL_HOME'
  },
  "LOGIN": {
    name: "login",
    url: "/login",
    value: 'MALL_LOGIN'
  },

  "REGISTER": {
    name: "register",
    url: "/register",
    value: 'MALL_REGISTER'
  },

  "SHOP": {
    name: "shop",
    url: "/shop",
    value: 'MALL_SHOP'
  },

  "HELP": {
    name: "help",
    url: "/help",
    value: 'MALL_HELP'
  },

  "CONTACT_US": {
    name: "contact_us",
    url: "/contact-us",
    value: 'MALL_CONTACT_US'
  },

  "HOW_IT_WORK": {
    name: "how_it_work",
    url: "/how_it_work",
    value: 'MALL_HOW_IT_WORK'
  },
  "SHOPPING_CART": {
    name: "shopping_cart",
    url: "/shopping_cart",
    value: 'MALL_SHOPPING_CART'
  },

  "MY_PROFILE": {
    name: "my_profile",
    url: "/my-profile",
    value: 'MALL_MY_PROFILE'
  },
  "USER_INFO": {
    name: "user_info",
    url: "/my_account/user_info",
    value: 'MALL_USER_INFO'
  },
  "ORDER_HISTORY": {
    name: "order_history",
    url: "/my_account/order_history",
    value: 'MALL_ORDER_HISTORY'
  },
}
// ---------- HEADER MENU ---------- 

export const HEADER_MENU_DATA = {

  "HOME": {
    name: "home",
    icon: `${TENANT_BUCKET}/icon/menu_home.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_home_active.png`,
    mobileShow: true,
    url: "/",
  },


  "PROMOTION": {
    name: "promotion",
    icon: `${TENANT_BUCKET}/icon/menu_promotion.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_promotion_active.png`,
    mobileShow: true,
    url: "/promotions",
  },

  "SHOP": {
    name: "shop",
    icon: `${TENANT_BUCKET}/icon/menu_shop.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_shop_active.png`,
    mobileShow: true,
    url: "/shop",
  }
  ,
  "HOW_IT_WORK": {
    name: "how_it_work",
    icon: `${TENANT_BUCKET}/icon/menu_how_it_work.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_how_it_work_active.png`,
    mobileShow: true,
    url: "/how_it_work",
  }
  ,
  "WEBSITE": {
    name: "back_to_website",
    icon: `${TENANT_BUCKET}/icon/menu_website.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/menu_website_active.png`,
    mobileShow: true,
    url: "/website",
  }
}

// ---------- FOOTER MENU ---------- 

export const FOOTER_MENU_DATA = {

  "ABOUT_US": {
    name: "about_us",
    mobileShow: true,
    url: "/help#about-us",
  },

  "TNC": {
    name: "tnc",
    mobileShow: true,
    url: "/help#term-and-conditions",
  },

  "FAQ": {
    name: "faq",
    mobileShow: true,
    url: "/help#faq",
  },

  "HOW_TO_DEPOSIT": {
    name: "how_to_deposit",
    mobileShow: true,
    url: "/help#how-to-deposit",
  },

  "HOW_TO_TRANSFER": {
    name: "how_to_transfer",
    mobileShow: true,
    url: "/help#how-to-transfer",
  },

  "HOW_TO_WITHDRAW": {
    name: "how_to_withdrawal",
    mobileShow: true,
    url: "/help#how-to-withdraw",
  },

  "CONTACT_US": {
    name: "contact_us",
    mobileShow: true,
    url: "/contact-us",
  },

  "VIP": {
    name: "vip",
    mobileShow: true,
    url: "/vip",
  }
}

// ---------- GAME MENU ---------- 

export const GAME_MENU_DATA = {

  "SL": {
    gameType: 'SL',
    name: "slots",
    icon: `${TENANT_BUCKET}/icon/game_menu_slot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_slot_active.png`,
    url: "/slots",
  },

  "LC": {
    gameType: 'LC',
    name: "live_casino",
    icon: `${TENANT_BUCKET}/icon/game_menu_casino.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_casino_active.png`,
    url: "/live-casino",
  },

  "APP": {
    gameType: 'APP',
    name: "mobile_slot",
    icon: `${TENANT_BUCKET}/icon/game_menu_mslot.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mslot_active.png`,
    url: "/mobile-slots",
  },

  "ES": {
    gameType: 'ES',
    name: "e-sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_esport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_esport_active.png`,
    url: "/esport",
  },

  "SB": {
    gameType: 'SB',
    name: "sport",
    icon: `${TENANT_BUCKET}/icon/game_menu_sport.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_sport_active.png`,
    url: "/sports",
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    icon: `${TENANT_BUCKET}/icon/game_menu_lottery.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_lottery_active.png`,
    url: "/lottery",
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    icon: `${TENANT_BUCKET}/icon/game_menu_fishing.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_fishing_active.png`,
    url: "/fishing",
  },

  "CB": {
    gameType: 'CB',
    name: "boardgame",
    icon: `${TENANT_BUCKET}/icon/game_menu_boardgame.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_boardgame_active.png`,
    url: "/board-game",
  },

  "PK": {
    gameType: 'PK',
    name: "poker",
    icon: `${TENANT_BUCKET}/icon/game_menu_poker.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_poker_active.png`,
    url: "/poker",
  }
  ,
  "MG": {
    gameType: 'MG',
    name: "mini_game",
    icon: `${TENANT_BUCKET}/icon/game_menu_mini_game.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_mini_game_active.png`,
    url: "/mini-game",
  },
  "OT": {
    gameType: 'OT',
    name: "others",
    icon: `${TENANT_BUCKET}/icon/game_menu_others.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/game_menu_others_active.png`,
    url: "/others",
  }


}

// ---------- SLOT ---------- 

export const SLOT_GAME_TYPE = {

  "ALL": {
    gameType: 'ALL',
    name: "all",
    label: 'gameType_all'
  },

  "SL": {
    gameType: 'SL',
    name: "slots",
    label: 'gameType_slots'
  },

  "AR": {
    gameType: 'AR',
    name: "arcade",
    label: 'gameType_arcade'
  },

  "LC": {
    gameType: 'LC',
    name: "table",
    label: 'gameType_table'
  },

  "FH": {
    gameType: 'FH',
    name: "fishing",
    label: 'gameType_fishing'
  },

  "LK": {
    gameType: 'LK',
    name: "lottery",
    label: 'lottery'
  },

  "OT": {
    gameType: 'OT',
    name: "other",
    label: 'other'
  },

  "BG": {
    gameType: 'BG',
    name: "bingo",
    label: 'bingo'
  },

  "FG": {
    gameType: 'FG',
    name: "featured games",
    label: 'featured games'
  },

  "FK": {
    gameType: 'FK',
    name: "funky",
    label: 'funky'
  },

  "MP": {
    gameType: 'MP',
    name: "multiplayer",
    label: 'multiplayer'
  },

  "SC": {
    gameType: 'SC',
    name: "scratch cards",
    label: 'scratch cards'
  },

  "SP": {
    gameType: 'SP',
    name: "single player",
    label: 'single player'
  },

  "TB": {
    gameType: 'TB',
    name: "table",
    label: 'gameType_table'
  },
}

// ---------- WALLET MENU ---------- 

export const WALLET_MENU_DATA =
{
  // funds: [{
  //   id: "0",
  //   name: "deposit",
  //   mobileName: 'deposit',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_deposit_active.png`,
  //   url: "/wallet/deposit",

  // }, {
  //   id: "1",
  //   name: "transfer_promo",
  //   mobileName: 'transfer',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_transfer_active.png`,
  //   url: "/wallet/transfer",

  // }, {
  //   id: "2",
  //   name: "withdraw",
  //   mobileName: 'withdraw',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_withdrawal_active.png`,
  //   url: "/wallet/withdraw",

  // }, {
  //   id: "3",
  //   name: "history",
  //   mobileName: 'history',
  //   icon: `${TENANT_BUCKET}/icon/bankingInfo_menu_history.png`,
  //   selectedIcon: `${TENANT_BUCKET}/icon/bankingInfo_menu_history_active.png`,
  //   url: "/wallet/history",

  // }],
  my_account: [{
    id: "4",
    name: "user_info",
    mobileName: 'user_info',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_userInfo_active.png`,
    url: "/my_account/user_info",

  }, {
    id: "5",
    name: "order_history",
    mobileName: 'order_history',
    icon: `${TENANT_BUCKET}/icon/myAccount_menu_orderHistory.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/myAccount_menu_orderHistory_active.png`,
    url: "/my_account/order_history",

  }]
}

// ---------- DEPOSIT MENU ---------- 

export const DEPOSIT_MENU_DATA = {

  "quickpay": {
    name: "quickpay",
    icon: `${TENANT_BUCKET}/icon/deposit_quickPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_quickPay_active.png`,
  },

  "banktransfer": {
    name: "banktransfer",
    icon: `${TENANT_BUCKET}/icon/deposit_bankTransfer.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_bankTransfer_active.png`,
  },

  "qrpay": {
    name: "qrpay",
    icon: `${TENANT_BUCKET}/icon/deposit_qrPay.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_qrPay_active.png`,
  },

  "reload": {
    name: "reload",
    icon: `${TENANT_BUCKET}/icon/deposit_reload.png`,
    selectedIcon: `${TENANT_BUCKET}/icon/deposit_reload_active.png`,

  }
}

// ---------- DEPOSIT METHOD DATA ----------


export const DEPOSIT_METHOD_DATA = {

  "truepay": {
    name: "truepay",
    label: "Truepay",
  },

  "ipay4u": {
    name: "ipay4u",
    label: "Ipay4u",
  },

  "online_transfer": {
    name: "online_transfer",
    label: "Online Transfer",
  },

  "atm_cash_deposit": {
    name: "atm_cash_deposit",
    label: "ATM Cash Deposit",
  },

  "cash_deposit": {
    name: "cash_deposit",
    label: "Cash Deposit",
  }
}

// ---------- BANK DATA ----------

export const BANK_DATA = {

  "PHBMMYKL": {
    id: "PHBMMYKL",
    name: "Affin Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PHBMMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PHBMMYKL.png`
  },

  "ARBKMYKL": {
    id: "ARBKMYKL",
    name: "Ambank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/ARBKMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/ARBKMYKL.png`
  },

  "BIMBMYKL": {
    id: "BIMBMYKL",
    name: "Bank Islam Malaysia",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BIMBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BIMBMYKL.png`
  },

  "BSNAMYK1": {
    id: "BSNAMYK1",
    name: "Bank Simpanan National",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/BSNAMYK1.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/BSNAMYK1.png`

  },

  "HLBBMYKL": {
    id: "HLBBMYKL",
    name: "Hong Leong Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/HLBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/HLBBMYKL.png`
  },

  "MBBEMYKL": {
    id: "MBBEMYKL",
    name: "Maybank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/MBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/MBBEMYKL.png`
  },

  "PBBEMYKL": {
    id: "PBBEMYKL",
    name: "Public Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/PBBEMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/PBBEMYKL.png`
  },

  "RHBBMYKL": {
    id: "RHBBMYKL",
    name: "RHB Bank Berhad",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/RHBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/RHBBMYKL.png`
  },

  "CIBBMYKL": {
    id: "CIBBMYKL",
    name: "CIMB Bank",
    country: 'MY',
    icon: `${GLOBAL_BUCKET}/bank/MYR/CIBBMYKL.png`,
    qrIcon: `${TENANT_BUCKET}/bank-qrcode/CIBBMYKL.png`
  },
}

// ---------- QR DATA ----------

export const QR_DATA = {

  "duitnow": {
    id: "duitnow",
    name: "DuitNow QR",
    icon: `${GLOBAL_BUCKET}/qrpay/MYS/duitnow.jpg`,
  },
}

// ---------- TRANSACTION TYPE DATA ----------

export const TRANSACTION_TYPE_DATA = {

  "transfer": {
    name: "transfer",
    url: "/wallet/history/transfer"
  },

  "betting_summary": {
    name: "betting_summary",
    url: "/wallet/history/betting_summary"
  },

  "deposit_withdrawal": {
    name: "deposit_withdrawal",
    url: "/wallet/history/deposit_withdrawal"
  },

  "promotion_apply": {
    name: "promotion_apply",
    url: "/wallet/history/promotion_apply"
  },

  "rebate": {
    name: "rebate",
    url: "/wallet/history/rebate"
  },

  "bonus": {
    name: "bonus",
    url: "/wallet/history/bonus"
  },
}

// ---------- USER VERIFICATION DATA ----------

export const USER_VERIFICATION_DATA = [
  {
    id: "phone_validated",
    name: "phone_number",
    // icon:<FaMobileAlt />,
  },
  {
    id: "email_validated",
    name: "email",
  },
  {
    id: "dob_validated",
    name: "dob",
    // icon: <FaAddressCard />,
  }
]

// ---------- SOCIAL MEDIA DATA ----------

export const SOCIAL_MEDIA_DATA = {

  "LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_chatwithus.png`,
  },

  "TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_telegram.png`,
  },

  "WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_whatsapp.png`,
  },

  "WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/contactUs_wechat.png`,
  },
  "SIDEBAR_LIVECHAT": {
    name: "LiveChat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_chatwithus.png`,
  },

  "SIDEBAR_TELEGRAM": {
    name: "Telegram",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_telegram.png`,
  },

  "SIDEBAR_WHATSAPP": {
    name: "Whatsapp",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_whatsapp.png`,
  },

  "SIDEBAR_WECHAT": {
    name: "Wechat",
    category: 'contactUs',
    icon: `${TENANT_BUCKET}/icon/sideBar_wechat.png`,
  },


  "TIKTOK": {
    name: "TikTok",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/tiktok.png`,
  },

  "YOUTUBE": {
    name: "YouTube",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/youtube.png`,
  },

  "TWITTER": {
    name: "Twiiter",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/twitter.png`,
  },

  "INSTAGRAM": {
    name: "Instagram",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/instagram.png`,
  },

  "FACEBOOK": {
    name: "Facebook",
    category: 'socialMedia',
    icon: `${GLOBAL_BUCKET}/social/facebook.png`,
  },
}

// ---------- GAME WALLET CATEGORY ----------
export const GAME_WALLET_CATEGORY = [
  ["SL", "LC", "FH", "APP"], ["SB", "ES"], ["CB", "LK", "PK", "MG"]
]

// ---------- HISTORY TABLE FIELD ----------
export const HISTORY_TABLE_FIELD = {

  "TRANSFER": {
    id: "TRANSFER",
    allAttr: ["from", "to", "amount", "transaction_date", "transaction_status"],
    selectedTableColumn: ["transaction_date", "to", "amount", "transaction_status"]
  },

  "BETTING_SUMMARY": {
    id: "BETTING_SUMMARY",
    allAttr: ["game_provider", "bet_count", "bet_amount", "valid_bet_amount", "total_bonus", "total_rebate"],
    selectedTableColumn: ["game_provider", "bet_count", "bet_amount"]
  },

  "DEPOSIT_WITHDRAW": {
    id: "DEPOSIT_WITHDRAW",
    allAttr: ["payment_type", "ticket_id", "amount", "transaction_date", "transaction_status", 'remark'],
    selectedTableColumn: ["paymentType_transactionDate", "amount", "transaction_status"]
  },

  "PROMOTION_APPLY": {
    id: "PROMOTION_APPLY",
    allAttr: ["ticket_id", "promotion_name", "to", "transfer_amount", "promo_bonus_amount", "target_amount", "transaction_date", "transaction_status", 'remark'],
    selectedTableColumn: ["promotion", "transfer_amount", "promo_bonus_amount", "transaction_status"]
  },

  "REBATE": {
    id: "REBATE",
    allAttr: ["release_date", "release_amount", "rebate_start_date", "rebate_end_date", "status"],
    selectedTableColumn: ["release_date", "release_amount", "rebate_start_date", "rebate_end_date", "status"]
  },

  "BONUS": {
    id: "BONUS",
    allAttr: ["from", "to", "amount", "transaction_date", "transaction_status"],
    selectedTableColumn: ["to", "amount", "transaction_status"]
  },
}

export const IMAGE_SIZE_DYNAMIC = {
  '1x1': {
    'desktop': {
      'none': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'right': {
        2: 320,
        3: 240
      },
      'bottom': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
      'insideImage': {
        4: 320,
        5: 240,
        6: 240,
        7: 150,
      },
    },
    'mobile': {
      'none': {
        2: 150,
        3: 150,
        4: 150,
      },
      'right': {
        1: 150,

      },
      'bottom': {
        2: 150,
        3: 150,
        4: 150,
      }, 'insideImage': {
        2: 150,
        3: 150,
        4: 150,
      }
    }
  },
  '1x2': {
    'desktop': {
      'none': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'right': {
        1: 750,
        2: 320
      },
      'bottom': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    },
    'mobile': {
      'none': {
        1: 320,
        2: 320,
        3: 320,
      },
      'right': {
        1: 320,

      },
      'bottom': {
        2: 320,
        3: 320,
        4: 320,
      },
      'insideImage': {
        2: 750,
        3: 480,
        4: 320,
        5: 320,
        6: 320,
      },
    }
  }
}


// ---------- WALLET MENU ---------- 


// COUNTRY LIST
export const COUNTRY_LIST = [
  { "name": "Albania", "code": "AL" },
  { "name": "Åland Islands", "code": "AX" },
  { "name": "Algeria", "code": "DZ" },
  { "name": "American Samoa", "code": "AS" },
  { "name": "Andorra", "code": "AD" },
  { "name": "Angola", "code": "AO" },
  { "name": "Anguilla", "code": "AI" },
  { "name": "Antarctica", "code": "AQ" },
  { "name": "Antigua and Barbuda", "code": "AG" },
  { "name": "Argentina", "code": "AR" },
  { "name": "Armenia", "code": "AM" },
  { "name": "Aruba", "code": "AW" },
  { "name": "Australia", "code": "AU" },
  { "name": "Austria", "code": "AT" },
  { "name": "Azerbaijan", "code": "AZ" },
  { "name": "Bahamas (the)", "code": "BS" },
  { "name": "Bahrain", "code": "BH" },
  { "name": "Bangladesh", "code": "BD" },
  { "name": "Barbados", "code": "BB" },
  { "name": "Belarus", "code": "BY" },
  { "name": "Belgium", "code": "BE" },
  { "name": "Belize", "code": "BZ" },
  { "name": "Benin", "code": "BJ" },
  { "name": "Bermuda", "code": "BM" },
  { "name": "Bhutan", "code": "BT" },
  { "name": "Bolivia (Plurinational State of)", "code": "BO" },
  { "name": "Bonaire, Sint Eustatius and Saba", "code": "BQ" },
  { "name": "Bosnia and Herzegovina", "code": "BA" },
  { "name": "Botswana", "code": "BW" },
  { "name": "Bouvet Island", "code": "BV" },
  { "name": "Brazil", "code": "BR" },
  { "name": "British Indian Ocean Territory (the)", "code": "IO" },
  { "name": "Brunei Darussalam", "code": "BN" },
  { "name": "Bulgaria", "code": "BG" },
  { "name": "Burkina Faso", "code": "BF" },
  { "name": "Burundi", "code": "BI" },
  { "name": "Cabo Verde", "code": "CV" },
  { "name": "Cambodia", "code": "KH" },
  { "name": "Cameroon", "code": "CM" },
  { "name": "Canada", "code": "CA" },
  { "name": "Cayman Islands (the)", "code": "KY" },
  { "name": "Central African Republic (the)", "code": "CF" },
  { "name": "Chad", "code": "TD" },
  { "name": "Chile", "code": "CL" },
  { "name": "China", "code": "CN" },
  { "name": "Christmas Island", "code": "CX" },
  { "name": "Cocos (Keeling) Islands (the)", "code": "CC" },
  { "name": "Colombia", "code": "CO" },
  { "name": "Comoros (the)", "code": "KM" },
  { "name": "Congo (the Democratic Republic of the)", "code": "CD" },
  { "name": "Congo (the)", "code": "CG" },
  { "name": "Cook Islands (the)", "code": "CK" },
  { "name": "Costa Rica", "code": "CR" },
  { "name": "Croatia", "code": "HR" },
  { "name": "Cuba", "code": "CU" },
  { "name": "Curaçao", "code": "CW" },
  { "name": "Cyprus", "code": "CY" },
  { "name": "Czechia", "code": "CZ" },
  { "name": "Côte d'Ivoire", "code": "CI" },
  { "name": "Denmark", "code": "DK" },
  { "name": "Djibouti", "code": "DJ" },
  { "name": "Dominica", "code": "DM" },
  { "name": "Dominican Republic (the)", "code": "DO" },
  { "name": "Ecuador", "code": "EC" },
  { "name": "Egypt", "code": "EG" },
  { "name": "El Salvador", "code": "SV" },
  { "name": "Equatorial Guinea", "code": "GQ" },
  { "name": "Eritrea", "code": "ER" },
  { "name": "Estonia", "code": "EE" },
  { "name": "Eswatini", "code": "SZ" },
  { "name": "Ethiopia", "code": "ET" },
  { "name": "Falkland Islands (the) [Malvinas]", "code": "FK" },
  { "name": "Faroe Islands (the)", "code": "FO" },
  { "name": "Fiji", "code": "FJ" },
  { "name": "Finland", "code": "FI" },
  { "name": "France", "code": "FR" },
  { "name": "French Guiana", "code": "GF" },
  { "name": "French Polynesia", "code": "PF" },
  { "name": "French Southern Territories (the)", "code": "TF" },
  { "name": "Gabon", "code": "GA" },
  { "name": "Gambia (the)", "code": "GM" },
  { "name": "Georgia", "code": "GE" },
  { "name": "Germany", "code": "DE" },
  { "name": "Ghana", "code": "GH" },
  { "name": "Gibraltar", "code": "GI" },
  { "name": "Greece", "code": "GR" },
  { "name": "Greenland", "code": "GL" },
  { "name": "Grenada", "code": "GD" },
  { "name": "Guadeloupe", "code": "GP" },
  { "name": "Guam", "code": "GU" },
  { "name": "Guatemala", "code": "GT" },
  { "name": "Guernsey", "code": "GG" },
  { "name": "Guinea", "code": "GN" },
  { "name": "Guinea-Bissau", "code": "GW" },
  { "name": "Guyana", "code": "GY" },
  { "name": "Haiti", "code": "HT" },
  { "name": "Heard Island and McDonald Islands", "code": "HM" },
  { "name": "Holy See (the)", "code": "VA" },
  { "name": "Honduras", "code": "HN" },
  { "name": "Hong Kong", "code": "HK" },
  { "name": "Hungary", "code": "HU" },
  { "name": "Iceland", "code": "IS" },
  { "name": "India", "code": "IN" },
  { "name": "Indonesia", "code": "ID" },
  { "name": "Iran (Islamic Republic of)", "code": "IR" },
  { "name": "Iraq", "code": "IQ" },
  { "name": "Ireland", "code": "IE" },
  { "name": "Isle of Man", "code": "IM" },
  { "name": "Israel", "code": "IL" },
  { "name": "Italy", "code": "IT" },
  { "name": "Jamaica", "code": "JM" },
  { "name": "Japan", "code": "JP" },
  { "name": "Jersey", "code": "JE" },
  { "name": "Jordan", "code": "JO" },
  { "name": "Kazakhstan", "code": "KZ" },
  { "name": "Kenya", "code": "KE" },
  { "name": "Kiribati", "code": "KI" },
  { "name": "Korea (the Democratic People's Republic of)", "code": "KP" },
  { "name": "Korea (the Republic of)", "code": "KR" },
  { "name": "Kuwait", "code": "KW" },
  { "name": "Kyrgyzstan", "code": "KG" },
  { "name": "Lao People's Democratic Republic (the)", "code": "LA" },
  { "name": "Latvia", "code": "LV" },
  { "name": "Lebanon", "code": "LB" },
  { "name": "Lesotho", "code": "LS" },
  { "name": "Liberia", "code": "LR" },
  { "name": "Libya", "code": "LY" },
  { "name": "Liechtenstein", "code": "LI" },
  { "name": "Lithuania", "code": "LT" },
  { "name": "Luxembourg", "code": "LU" },
  { "name": "Macao", "code": "MO" },
  { "name": "Madagascar", "code": "MG" },
  { "name": "Malawi", "code": "MW" },
  { "name": "Malaysia", "code": "MY" },
  { "name": "Maldives", "code": "MV" },
  { "name": "Mali", "code": "ML" },
  { "name": "Malta", "code": "MT" },
  { "name": "Marshall Islands (the)", "code": "MH" },
  { "name": "Martinique", "code": "MQ" },
  { "name": "Mauritania", "code": "MR" },
  { "name": "Mauritius", "code": "MU" },
  { "name": "Mayotte", "code": "YT" },
  { "name": "Mexico", "code": "MX" },
  { "name": "Micronesia (Federated States of)", "code": "FM" },
  { "name": "Moldova (the Republic of)", "code": "MD" },
  { "name": "Monaco", "code": "MC" },
  { "name": "Mongolia", "code": "MN" },
  { "name": "Montenegro", "code": "ME" },
  { "name": "Montserrat", "code": "MS" },
  { "name": "Morocco", "code": "MA" },
  { "name": "Mozambique", "code": "MZ" },
  { "name": "Myanmar", "code": "MM" },
  { "name": "Namibia", "code": "NA" },
  { "name": "Nauru", "code": "NR" },
  { "name": "Nepal", "code": "NP" },
  { "name": "Netherlands (the)", "code": "NL" },
  { "name": "New Caledonia", "code": "NC" },
  { "name": "New Zealand", "code": "NZ" },
  { "name": "Nicaragua", "code": "NI" },
  { "name": "Niger (the)", "code": "NE" },
  { "name": "Nigeria", "code": "NG" },
  { "name": "Niue", "code": "NU" },
  { "name": "Norfolk Island", "code": "NF" },
  { "name": "Northern Mariana Islands (the)", "code": "MP" },
  { "name": "Norway", "code": "NO" },
  { "name": "Oman", "code": "OM" },
  { "name": "Pakistan", "code": "PK" },
  { "name": "Palau", "code": "PW" },
  { "name": "Palestine, State of", "code": "PS" },
  { "name": "Panama", "code": "PA" },
  { "name": "Papua New Guinea", "code": "PG" },
  { "name": "Paraguay", "code": "PY" },
  { "name": "Peru", "code": "PE" },
  { "name": "Philippines (the)", "code": "PH" },
  { "name": "Pitcairn", "code": "PN" },
  { "name": "Poland", "code": "PL" },
  { "name": "Portugal", "code": "PT" },
  { "name": "Puerto Rico", "code": "PR" },
  { "name": "Qatar", "code": "QA" },
  { "name": "Republic of North Macedonia", "code": "MK" },
  { "name": "Romania", "code": "RO" },
  { "name": "Russian Federation (the)", "code": "RU" },
  { "name": "Rwanda", "code": "RW" },
  { "name": "Réunion", "code": "RE" },
  { "name": "Saint Barthélemy", "code": "BL" },
  { "name": "Saint Helena, Ascension and Tristan da Cunha", "code": "SH" },
  { "name": "Saint Kitts and Nevis", "code": "KN" },
  { "name": "Saint Lucia", "code": "LC" },
  { "name": "Saint Martin (French part)", "code": "MF" },
  { "name": "Saint Pierre and Miquelon", "code": "PM" },
  { "name": "Saint Vincent and the Grenadines", "code": "VC" },
  { "name": "Samoa", "code": "WS" },
  { "name": "San Marino", "code": "SM" },
  { "name": "Sao Tome and Principe", "code": "ST" },
  { "name": "Saudi Arabia", "code": "SA" },
  { "name": "Senegal", "code": "SN" },
  { "name": "Serbia", "code": "RS" },
  { "name": "Seychelles", "code": "SC" },
  { "name": "Sierra Leone", "code": "SL" },
  { "name": "Singapore", "code": "SG" },
  { "name": "Sint Maarten (Dutch part)", "code": "SX" },
  { "name": "Slovakia", "code": "SK" },
  { "name": "Slovenia", "code": "SI" },
  { "name": "Solomon Islands", "code": "SB" },
  { "name": "Somalia", "code": "SO" },
  { "name": "South Africa", "code": "ZA" },
  { "name": "South Georgia and the South Sandwich Islands", "code": "GS" },
  { "name": "South Sudan", "code": "SS" },
  { "name": "Spain", "code": "ES" },
  { "name": "Sri Lanka", "code": "LK" },
  { "name": "Sudan (the)", "code": "SD" },
  { "name": "Suriname", "code": "SR" },
  { "name": "Svalbard and Jan Mayen", "code": "SJ" },
  { "name": "Sweden", "code": "SE" },
  { "name": "Switzerland", "code": "CH" },
  { "name": "Syrian Arab Republic", "code": "SY" },
  { "name": "Taiwan (Province of China)", "code": "TW" },
  { "name": "Tajikistan", "code": "TJ" },
  { "name": "Tanzania, United Republic of", "code": "TZ" },
  { "name": "Thailand", "code": "TH" },
  { "name": "Timor-Leste", "code": "TL" },
  { "name": "Togo", "code": "TG" },
  { "name": "Tokelau", "code": "TK" },
  { "name": "Tonga", "code": "TO" },
  { "name": "Trinidad and Tobago", "code": "TT" },
  { "name": "Tunisia", "code": "TN" },
  { "name": "Turkey", "code": "TR" },
  { "name": "Turkmenistan", "code": "TM" },
  { "name": "Turks and Caicos Islands (the)", "code": "TC" },
  { "name": "Tuvalu", "code": "TV" },
  { "name": "Uganda", "code": "UG" },
  { "name": "Ukraine", "code": "UA" },
  { "name": "United Arab Emirates (the)", "code": "AE" },
  { "name": "United Kingdom of Great Britain and Northern Ireland (the)", "code": "GB" },
  { "name": "United States Minor Outlying Islands (the)", "code": "UM" },
  { "name": "United States of America (the)", "code": "US" },
  { "name": "Uruguay", "code": "UY" },
  { "name": "Uzbekistan", "code": "UZ" },
  { "name": "Vanuatu", "code": "VU" },
  { "name": "Venezuela (Bolivarian Republic of)", "code": "VE" },
  { "name": "Viet Nam", "code": "VN" },
  { "name": "Virgin Islands (British)", "code": "VG" },
  { "name": "Virgin Islands (U.S.)", "code": "VI" },
  { "name": "Wallis and Futuna", "code": "WF" },
  { "name": "Western Sahara", "code": "EH" },
  { "name": "Yemen", "code": "YE" },
  { "name": "Zambia", "code": "ZM" },
  { "name": "Zimbabwe", "code": "ZW" }
]

